import { lazy } from 'react';

import { ForgotPasswordRouteBase } from '@/App/AppRoutes/ForgotPasswordRouteBase';
import type { AppRouteConfig } from '@/App/AppRoutes/types';

const ForgotPasswordPage = lazy(() =>
  import('@/components/pages/ForgotPasswordPage').then(({ ForgotPasswordPage }) => ({ default: ForgotPasswordPage })),
);

export const ForgotPasswordRoute: AppRouteConfig = {
  ...ForgotPasswordRouteBase,
  component: ForgotPasswordPage,
};
